<template>
  <div style="position:relative;">
    <el-form-item
      v-if="visible"
      class="form form-input pos-relative"
      :label="column.label"
      :prop="column.name">
      <!-- <span>{{ form[column.gname] }}</span> -->
      <el-input
        :name="column ? column.name : 'invalid'"
        :type="column.inputType || 'text'"
        v-model="modelValue"
        :maxlength="column.maxlength || undefined"
        :disabled="disabled || false"
        :readonly="column.readonly || false"
        :autosize="column.autoSize || {}"
        :autoComplete="column.autoComplete || 'off'"
        :placeholder="column.placeholder || ''"
        @input="onInput">

        <!-- prepend -->
        <div
          slot="prepend"
          v-if="column.prepend &&
            typeof column.prepend === 'string'"
          :style="column.prependStyle || {}">
          {{ column.prepend }}
        </div>

        <el-select
          slot="prepend"
          v-else-if="column.prepend &&
            column.prepend.type === 'select'"
          :name="column.prepend.name"
          v-model="form[column.prepend.name]"
          :style="column.prepend.style || {}">
          <el-option
            v-for="(option, oindex) in (getData(column.prepend.data) || [])"
            :key="`${oindex}`"
            :value="option.id"
            :label="option.label">
            {{ option.label }}
          </el-option>
        </el-select>

        <el-button
          slot="prepend"
          v-else-if="column.prepend &&
            column.prepend.type === 'button'"
          :type="column.append.buttonType"
          :style="column.prepend.style || {}"
          @click="onButton('prepend')">
          <div
            v-if="column.prepend.label">
            {{ column.prepend.label }}
          </div>
          <div
            v-else-if="column.prepend.icon">
            <i :class="`el-icon-${column.prepend.icon}`"></i>
          </div>
        </el-button>

        <div
          slot="prepend"
          v-if="column.prependLabel"
          :style="column.prependStyle || {}">
          {{ column.prependLabel }}
        </div>

        <!-- append -->
        <div
          slot="append"
          v-if="column.append &&
            typeof column.append === 'string'"
          :style="column.appendStyle || {}">
          {{ column.append }}
        </div>

        <el-select
          slot="append"
          v-else-if="column.append && column.append.type === 'select'"
          :name="column.append.name"
          v-model="form[column.append.name]"
          :style="column.append.style || {}">
          <el-option
            v-for="(option, oindex) in (getData(column.append.data) || [])"
            :key="`${oindex}`"
            :value="option.id"
            :label="option.label">
            {{ option.label }}
          </el-option>
        </el-select>

        <el-button
          slot="append"
          v-else-if="column.append &&
            column.append.type === 'button'"
          :type="column.append.buttonType"
          :style="column.append.style || {}"
          @click="onButton('append')">
          <div
            v-if="column.append.label">
            {{ column.append.label }}
          </div>
          <div
            v-else-if="column.append.icon">
            <i :class="`el-icon-${column.append.icon}`"></i>
          </div>
        </el-button>

        <div
          slot="append"
          v-else-if="column.append &&
            column.append.type === 'checkmark'"
          :class="column.append.class || ''"
          :style="column.append.style || {}">
          <div>
            <i v-if="form.hasOwnProperty(column.append.name) && form[column.append.name] === true"
              :class="`el-icon-${column.append.iconTrue}`">
            </i>
            <i v-else-if="form.hasOwnProperty(column.append.name) && form[column.append.name] === false"
              :class="`el-icon-${column.append.iconFalse}`">
            </i>
            <i v-else-if="form.hasOwnProperty(column.append.name) && form[column.append.name] === null"
              :class="`el-icon-${column.append.iconNull}`">
            </i>
            <i v-else
              class="el-icon-loading">
            </i>
          </div>
        </div>

        <div
          slot="append"
          v-if="column.appendLabel"
          :style="column.appendStyle || {}">
          {{ column.appendLabel }}
        </div>

        <!-- prefix/suffix -->
        <div v-if="column.prefixInfo" slot="prefix">
          <el-tooltip effect="dark" placement="top" popper-class="tooltip-content">
            <div slot="content" v-html="column.prefixInfo && column.prefixInfo.label"></div>
            <i class="header-icon el-icon-info tooltip-info-icon"
              :style="((column.prependLabel && column.prependLabel.length > 0) ? { marginTop: '14px' } : {})">
            </i>
          </el-tooltip>
        </div>

        <i
          v-if="column.prefixLabel" slot="prefix"
          :class="column.prefixClass">
          {{ column.prefixLabel }}
        </i>

        <i
          v-if="column.suffixLabel" slot="suffix"
          :class="column.suffixClass">
          {{ column.suffixLabel }}
        </i>

        <el-button
          slot="suffix"
          v-else-if="column.suffix &&
            column.suffix.type === 'button' &&
            !stateSuffixHidden"
          :type="column.suffix.buttonType"
          :size="column.suffix.size"
          :style="column.suffix.style || {}"
          @click="onButton('suffix')">
          <div
            v-if="column.suffix.label">
            {{ column.suffix.label }}
          </div>
          <div
            v-else-if="column.suffix.icon">
            <i :class="`el-icon-${column.suffix.icon}`"></i>
          </div>
        </el-button>

        <!-- <div slot="suffix" v-if="column.showWordLimit && column.maxlength">
          {{ form[column.name] && `${form[column.name]}`.length > 0 ? `${form[column.name]}`.length : 0 }} / {{ column.maxlength }}
        </div> -->
      </el-input>

      <div v-if="column.inputType === 'textarea' && column.prefixInfo"
        class="pos-absolute"
        :style="column.prefixInfo.hasOwnProperty('styleWrapper') ?
          column.prefixInfo.styleWrapper :
          { top: '0', left: '100px' }">
        <el-tooltip effect="dark" placement="top" popper-class="tooltip-content">
          <div slot="content" v-html="column.prefixInfo.label"></div>
          <i class="header-icon el-icon-info tooltip-info-icon"></i>
        </el-tooltip>
      </div>
    </el-form-item>

    <div slot="suffix" v-if="column.showWordLimit && column.maxlength"
      style="font-size:0.8em;color:gray;text-align:right;position:absolute;bottom:-15px;right:0;">
      {{ form[column.name] && `${form[column.name]}`.length > 0 ? `${form[column.name]}`.length : 0 }} / {{ column.maxlength }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Util from '@/util'

export default {
  name: 'form-input',
  components: {
  },
  props: ['column', 'form', 'data', 'disabled'],
  data () {
    return {
      visible: true,
      // dataInt: {}
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
    Util: function () {
      return Util
    },

    // stateSuffixDisabled: function () {
    //   // form state
    //   let form = this.form
    //   let column = this.column
    //   if (form.hasOwnProperty(`${column.suffix && column.suffix.name}State`)) {
    //     let state = form[`${column.suffix && column.suffix.name}State`]
    //     if (state.hasOwnProperty('disabled')) {
    //       return state.disabled
    //     }
    //   }
    //   // column
    //   if (column.hasOwnProperty('disabled')) {
    //     return column.disabled
    //   }
    //   return this.disabled
    // },

    stateSuffixHidden: function () {
      // form state
      let form = this.form
      let column = this.column
      if (form.hasOwnProperty(`${column.suffix && column.suffix.name}State`)) {
        let state = form[`${column.suffix && column.suffix.name}State`]
        if (state.hasOwnProperty('hidden')) {
          return state.hidden
        }
      }
      // column
      if (column.suffix && column.suffix.hasOwnProperty('hidden')) {
        return column.suffix.hidden
      }
      return false
    },

    modelValue: {
      get () {
        // console.log('-- get', {
        //   instance: this,
        //   column: this.column,
        //   form: this.form
        // })
        if (this.column.hasOwnProperty('path')) {
          if (this.column.path.indexOf('.') >= 0) {
            return Util.object.get(this.form, this.column.path)
          } else {
            return this.form[this.column.path]
          }
        } else {
          return this.form[this.column.name]
        }
      },
      set (newVal) {
        // console.log('-- set', {
        //   instance: this,
        //   newVal
        // })
        if (this.column.hasOwnProperty('path')) {
          if (this.column.path.indexOf('.') >= 0) {
            let path = this.column.path
            let keyInfo = Util.object.keys(path)
            let keyFirst = keyInfo.keyFirst
            let keyLast = keyInfo.keyLast
            let obj = Util.object.get(this.form, keyFirst)
            // console.log('-- set input', {
            //   instance: this,
            //   path,
            //   keyFirst,
            //   keyLast,
            //   newVal,
            //   isSame: (obj === this.form[keyFirst][keyLast])
            // })
            this.$set(obj, keyLast, newVal)
            // console.log('-- after set', this.form)
          } else {
            this.$set(this.form, this.column.path, newVal)
          }
        } else {
          this.$set(this.form, this.column.name, newVal)
        }
      }
    },

    appendWatch () {
      if (!this.form || !this.column || !this.column.append || !this.column.append.name) {
        return undefined
      }
      return this.form[this.column.append.name]
    },

    prependWatch () {
      if (!this.form || !this.column || !this.column.prepend || !this.column.prepend.name) {
        return undefined
      }
      return this.form[this.column.prepend.name]
    },

    // dataWatch () {
    //   let all = ''
    //   for (let key in this.data) {
    //     let dt = this.data[key]
    //     if (!Array.isArray(dt)) continue
    //     for (let i in dt) {
    //       let item = dt[i]
    //       all += `d=${key}/i=${i}/${item ? item.id : 'null'}|`
    //     }
    //   }
    //   return all
    // }
  },
  watch: {
    data: function (value) {
      // console.log('data watcher', value)
      this.refresh()
    },

    'appendWatch': function (value, valueOld) {
      let append = this.column ? this.column.append : {}
      this.onSelectChanged('append', append, { value, valueOld })
    },

    'prependWatch': function (value, valueOld) {
      let prepend = this.column ? this.column.prepend : {}
      this.onSelectChanged('prepend', prepend, { value, valueOld })
    }
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
      // this.$set(this, 'visible', false)
      // for (let key in this.data) {
      //   let dt = this.data[key]
      //   console.log('-- data change', {
      //     key,
      //     dt
      //   })
      //   this.$set(this.dataInt, key, dt)
      // }
      // this.$nextTick(() => {
      //   this.$set(this, 'visible', true)
      // })
    },

    getData (name) {
      if (this.data && this.data[name] && typeof this.data[name] === 'object') {
        return this.data[name]
      }
      return []
    },

    onInput () {
      let value = this.modelValue
      let info = _.assign({}, this.column, { value })
      this.$emit('on-input', info)
    },

    onSelectChanged (selectType, info, extraInfo = {}) {
      let data = _.assign({}, this.column, { selectType })
      data = _.assign(data, info) // info
      data = _.assign(data, extraInfo) // extra info
      let value = (info && info.name) ? this.form[info.name] : undefined
      data = _.assign(data, { value }) // value
      this.$emit('on-select-changed', data)
    },

    onButton (buttonType) {
      let value = this.modelValue
      let info = _.assign({}, this.column, { value, buttonType })
      this.$emit('on-button', info)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-input {
  .el-input__inner {
    &[readonly=readonly] {
      background-color: #f5f7fa !important;
    }
  }

  .el-input-group__append button.el-button,
  .el-input-group__append div.el-select .el-input__inner,
  .el-input-group__append div.el-select:hover .el-input__inner,
  .el-input-group__prepend button.el-button,
  .el-input-group__prepend div.el-select .el-input__inner,
  .el-input-group__prepend div.el-select:hover .el-input__inner {
    background-color: transparent !important;
  }
}

</style>
